import {
  Box,
  Button,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import {
  FieldArray as FieldArrayOptions,
  Path,
  useFieldArray,
  UseFieldArrayProps,
} from 'react-hook-form'

import { Icon } from '@/components/Icon'

import { VailTextField } from '../TextField'

export type FieldArrayProps<T extends object> = UseFieldArrayProps<T> & {
  label: string
  helperText?: string
  appendLabel?: string
  textFieldLabel?: string
}

export const FieldArray = <T extends object>(props: FieldArrayProps<T>) => {
  const { fields, append, remove } = useFieldArray({
    control: props.control,
    name: props.name,
  })

  return (
    <Box>
      <Box sx={{ py: 2 }}>
        <Typography fontWeight="bold">{props.label}</Typography>
        <Typography variant="caption">{props.helperText}</Typography>
      </Box>
      <Stack divider={<Divider />} spacing={2}>
        {fields.map((field, index) => (
          <Stack key={field.id} alignItems="center" direction="row" spacing={1}>
            <VailTextField
              multiline
              control={props.control}
              helperText="Each new line is a new bubble message"
              label={props.textFieldLabel || props.label}
              minRows={5}
              name={`${props.name}.${index}.value` as Path<T>}
            />
            <IconButton
              onClick={() => {
                remove(index)
              }}
            >
              <Icon name="delete" />
            </IconButton>
          </Stack>
        ))}
      </Stack>
      <Button
        startIcon={<Icon name="add" />}
        sx={{ alignSelf: 'flex-start' }}
        onClick={() =>
          append({
            value: '',
          } as FieldArrayOptions<T>)
        }
      >
        {props.appendLabel || props.label}
      </Button>
    </Box>
  )
}
